import { useEffect, useState } from 'react';
import axios from 'axios';
import { resolveImageUrl } from '@/components/admin/ImageUploader';
import { API } from '@/lib/api';


// In-memory cache so we fetch hero images once per session
let _heroImagesCache = null;
let _heroImagesPromise = null;

function loadHeroImages() {
  if (_heroImagesCache) return Promise.resolve(_heroImagesCache);
  if (_heroImagesPromise) return _heroImagesPromise;
  _heroImagesPromise = axios
    .get(`${API}/content/hero-images`)
    .then((r) => {
      _heroImagesCache = r.data || {};
      return _heroImagesCache;
    })
    .catch(() => {
      _heroImagesCache = {};
      return _heroImagesCache;
    });
  return _heroImagesPromise;
}

/**
 * Returns the image URL + alt for a given page key (e.g. "/", "/about"),
 * falling back to the provided defaultImage/defaultAlt if none is customized in admin.
 */
export function useHeroImage(pageKey, defaultImage, defaultAlt = '') {
  const [data, setData] = useState({ image_url: defaultImage, alt: defaultAlt });

  useEffect(() => {
    let mounted = true;
    loadHeroImages().then((map) => {
      if (!mounted) return;
      const custom = map[pageKey];
      if (custom && custom.image_url) {
        setData({
          image_url: resolveImageUrl(custom.image_url),
          alt: custom.alt || defaultAlt,
        });
      }
    });
    return () => {
      mounted = false;
    };
  }, [pageKey, defaultAlt]);

  return data;
}
